import { computed, unref } from 'vue';
import { STATES_VALUE } from '@/presentation/constants/shared/state.constant';
import { normalizeBusinessWorkHours } from '@/presentation/modules/business/utils/workHours.mapper';

export const BUSINESS_ONBOARDING_ROUTE_NAME = 'BusinessOnboarding';
export const BUSINESS_ONBOARDING_ROUTE_PATH = '/dashboard/business-onboarding';

export const LOCKED_BUSINESS_ROUTE_NAMES = new Set([
	'DashboardWallet',
	'DashboardWithdraw',
	'DashboardCreditCharge',
	'DashboardCustomers',
	'DashboardRequestRoot',
	'DashboardRequests',
	'DashboardReceiveRequests',
	'BookAppointment',
	'DashboardSendSms',
]);

const hasValue = (value: any) => {
	if (value === null || value === undefined) return false;
	if (typeof value === 'string') return value.trim().length > 0;
	if (typeof value === 'number') return true;
	if (typeof value === 'object') return Boolean(value.faName || value.key || value.id);
	return Boolean(value);
};

export const isBusinessWorkHoursComplete = (businessInfo: any) => {
	return normalizeBusinessWorkHours(businessInfo).length > 0;
};

export const normalizeBusinessState = (state?: string | null) => String(state || '').trim();

export const getBusinessRequiredFields = (businessInfo: any) => [
	{ key: 'name', label: 'نام کسب و کار', done: hasValue(businessInfo?.name) },
	{ key: 'city', label: 'شهر', done: hasValue(businessInfo?.city) },
	{ key: 'address', label: 'آدرس کامل', done: hasValue(businessInfo?.address) },
	{ key: 'description', label: 'توضیح کوتاه', done: hasValue(businessInfo?.description) },
];

export const isBusinessProfileComplete = (businessInfo: any) => getBusinessRequiredFields(businessInfo).every((field) => field.done);

export const getBusinessOnboardingFlags = (businessInfo: any) => {
	const state = normalizeBusinessState(businessInfo?.state);
	const isValid = state === STATES_VALUE.valid;
	const isWaiting = state === STATES_VALUE.waiting;
	const isRejected = state === STATES_VALUE.invalid || state === 'Invalid' || state === 'Rejected';
	const hasPaymentCard = hasValue(businessInfo?.cardNumber);
	const isProfileComplete = isBusinessProfileComplete(businessInfo);
	const isIncomplete = !isProfileComplete || !state;

	return {
		state,
		isValid,
		isWaiting,
		isRejected,
		hasPaymentCard,
		isProfileComplete,
		isIncomplete,
		isFullyActive: isValid && isProfileComplete,
		needsOnboarding: !isValid && (isIncomplete || isWaiting || isRejected),
		canAccessLimitedDashboard: (isWaiting || isRejected) && isProfileComplete,
	};
};

export function useBusinessOnboardingState(businessInfo: any) {
	const info = computed(() => unref(businessInfo) || {});
	const flags = computed(() => getBusinessOnboardingFlags(info.value));
	const requiredFields = computed(() => getBusinessRequiredFields(info.value));

	return {
		businessInfo: info,
		requiredFields,
		flags,
	};
}
